import TRINITY_BOND_ABI from '../../abis/TrinityBond.json'
import TRINITY_ENTITY_ABI from '../../abis/TrinityEntity.json'
import TRINITY_PRODUCT_ABI from '../../abis/TrinityProduct.json'
import TRINITY_PROPERTIES_ABI from '../../abis/TrinityProperties.json'
import ERC20_ABI from '../../abis/MockERC20.json'
import TRINITY_ABI from '../../abis/Trinity.json'
import NT_ABI from '../../abis/NT.json'

// Backend configuration
export const BACKEND_CONFIG = {
  URL: import.meta.env.VITE_BACKEND_URL || 'http://localhost:5001',
  PORT: import.meta.env.VITE_BACKEND_PORT || '5001',
  HEALTH_ENDPOINT: '/api/health',
  UPLOAD_ENDPOINT: '/api/upload',
  UPLOAD_DIRECTORY_ENDPOINT: '/api/upload-directory',
} as const

export const CONFIG = {
  TRINITY_BOND_ABI,
  TRINITY_ENTITY_ABI,
  TRINITY_PRODUCT_ABI,
  TRINITY_PROPERTIES_ABI,
  ERC20_ABI,
  TRINITY_ABI,
  NT_ABI,
  BACKEND: BACKEND_CONFIG,
} as const 